import "./LogoBrand.scss";
import { useSelector, shallowEqual } from "react-redux";
import LogoBrand from "app/pages/.shared/LogoBrand/LogoBrand";
import { getTheme } from "app/reducers/partnerSelector";

const mapStateToProps = state => {
	return {
		shop: state.shop,
		brand: state.brand.code,
		theme: getTheme(state),
		partnerCode: state.partner.code,
	};
};

const LogoBrandContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <LogoBrand {...props} {...stateProps} />;
};

export default LogoBrandContainer;
